import { render, staticRenderFns } from "./addresssearch.vue?vue&type=template&id=60873886"
import script from "./addresssearch.vue?vue&type=script&lang=js"
export * from "./addresssearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports